import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors,
} from "@dnd-kit/core";
import type { DragEndEvent } from "@dnd-kit/core";
import {
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import type { ComplianceQuestion } from "newui/features/Settings/types/ComplianceQuestion.type";
import { SortableQuestionRow } from "../SortableQuestionRow";

interface ComplianceQuestionsListProps {
	questions: ComplianceQuestion[];
	savingId: number | null;
	onEdit: (id: number, question: string) => void;
	onDelete: (id: number) => void;
	onDragEnd: (event: DragEndEvent) => void;
}

export const ComplianceQuestionsList = ({
	questions,
	savingId,
	onEdit,
	onDelete,
	onDragEnd,
}: ComplianceQuestionsListProps) => {
	const sensors = useSensors(
		useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		})
	);

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragEnd={onDragEnd}
		>
			<SortableContext
				items={questions.map((q) => q.id)}
				strategy={verticalListSortingStrategy}
			>
				<div
					className="overflow-hidden rounded-md border border-gray-200"
					data-testid="compliance-questions-list"
				>
					{questions.map((question) => (
						<SortableQuestionRow
							key={question.id}
							question={question}
							isSaving={savingId === question.id}
							onEdit={onEdit}
							onDelete={onDelete}
						/>
					))}
				</div>
			</SortableContext>
		</DndContext>
	);
};
